import { useAuth0 } from '@auth0/auth0-react'
import styled from '@emotion/styled'
import { CheckCircleOutline, Close } from '@mui/icons-material'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Input,
  Modal,
  Paper,
  Typography,
  useTheme,
} from '@mui/material'
import { GoogleMap, MarkerF, StandaloneSearchBox } from '@react-google-maps/api'
import moment from 'moment'
import { Fragment, useContext, useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
  CameraIcon,
  ChevBackIcon,
  DeleteNew,
  DownloadIconNew,
  ShareIcon,
} from '../../assets/icons/icons'
import { Fetching } from '../../components/Fetching'
import { formatDateTime } from '../../lib/time'
import { FilterPhotos } from './FilterPhotos'
import { useDeleteProjectPhoto, useUpdateProjectPhoto } from './hooks'
import { ProjectsUploader } from './uploads/ProjectsUploader'
import SelectTagsComponent from './uploads/SelectTagsComponent'
import { useGetProjectImages } from './uploads/hooks'
import ShareDialogComponent from './ShareDialogComponent';
import SnackBarContext from '../../context/SnackBarContext'

const imageTypes=['image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/bmp',
  'image/tiff',
  'image/svg+xml']
const Item = styled(Paper)(({ theme }: any) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}))

export const ProjectPhotos = (props: any) => {
  const { id } = useParams()
  const { isLoading, user } = useAuth0()
  const theme = useTheme()
  const navigate = useNavigate()

  const [images, setImages] = useState<any>({})

  const [isFetching, setIsFetching] = useState(false)

  if (isLoading || isFetching) {
    return <Fetching />
  }

  return (
    <Box sx={{ padding: '0 16px' }}>
      <Box sx={{ marginTop: 1, marginLeft: 2, marginRight: 2 }}>
        <IconButton
          sx={{
            background: '#24212C12',
            borderRadius: 1.8,
            padding: '6px 10px',
          }}
          onClick={() => navigate('/projects/' + id)}>
          <ChevBackIcon />{' '}
          <p
            style={{
              fontSize: 12,
              paddingTop: 0,
              paddingRight: 0,
              paddingBottom: 0,
              margin: 0,
              paddingLeft: 7,
            }}>
            Go Back
          </p>
        </IconButton>
        <Box
          alignItems={'center'}
          justifyContent={'space-between'}
          display={'flex'}>
          <Box sx={{ marginTop: 2 }}>
            <Typography
              style={{
                fontSize: 36,
                fontWeight: '600',
                fontFamily: 'Rza',
                padding: 0,
                margin: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              Photos{' '}
              {images?.data?.length > 0 && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(36, 33, 44, 0.08)',
                    color: 'rgba(36, 33, 44, 0.5)',
                    padding: '4px 10px',
                    borderRadius: 10,
                    marginLeft: 1,
                  }}>
                  <Typography sx={{ fontSize: 15 }}>
                    {images?.data?.length}
                  </Typography>
                </Box>
              )}
            </Typography>
          </Box>
          <Box alignItems={'center'} justifyContent={'center'} display={'flex'}>
            <FilterPhotos setImages={setImages} setIsFetching={setIsFetching} />
            <ProjectsUploader />
          </Box>
        </Box>
        {/* Images Box */}
        <Box
          marginTop={3}
          display='flex'
          alignItems='center'
          justifyContent={'center'}
          sx={{
            width: '100%',
            backgroundColor: 'white',
            padding: 2,
            boxShadow: '0px 2px 4px 0px #0000000D',
            borderRadius: '8px',
          }}>
          <Grid container spacing={2}>
            {images?.data?.length == 0 && (
              <Box
                sx={{
                  height: 200,
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  paddingTop: 2,
                }}>
                <Typography sx={{ fontSize: 20 }}>No Photos Found!</Typography>
              </Box>
            )}
            {images?.data?.length > 0 &&
              images?.data?.map((item: any) => {
                return <ProjectPhoto item={item} theme={theme} />
              })}
          </Grid>
        </Box>
      </Box>
    </Box>
  )
}

const ProjectPhoto = ({ item, theme }: any) => {
  const [openShareDialog, setOpenShareDialog] = useState(false);

  const handleShareDialogOpen = () => {
    setOpenShareDialog(true);
  };

  const handleShareDialogClose = () => {
    setOpenShareDialog(false);
  };

  // Function to copy photo URL to clipboard
  const copyPhotoUrlToClipboard = () => {
    navigator.clipboard.writeText(item.filePath);
    alert('Photo URL copied to clipboard!');
  };
  // Use Ref
  const locationFieldRef: any = useRef()

  // Use States
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [open, setOpen] = useState(false)
  const [openDetailModal, setOpenDetailModal] = useState(false)

  const [selectedTab, setSelectedTab] = useState('Details')

  const [title, setTitle] = useState('')

  const [lat, setLat] = useState<any>(null)
  const [lng, setLng] = useState<any>(null)
  const [location, setLocation] = useState('')

  const [tags, setTags] = useState<any[]>([])
  const [openDialog,setOpenDialog]=useState<boolean>(false)
  const {toggleSnackbar}=useContext(SnackBarContext)
  const { mutate, isLoading: isLoadingDelete } = useDeleteProjectPhoto(
    'delete-project-photo'
  )

  const { mutateAsync: updateProjectImages, isLoading: isUploadLoading } =
    useUpdateProjectPhoto('projects')
  const shareOnFacebook = () => {
    const url = encodeURIComponent(item.filePath);
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    window.open(facebookShareUrl, '_blank');
  };
  const shareViaEmail = () => {
    const subject = encodeURIComponent('Check out this photo');
    const body = encodeURIComponent(`I thought you might be interested: ${item.filePath}`);
    const emailShareUrl = `mailto:?subject=${subject}&body=${body}`;
    window.location.href = emailShareUrl;
  };

  // Download Image
  const downloadImage = async (imagePath: string) => {
    fetch(imagePath)
      .then(response => response.blob())
      .then(blob => {
        const blobUrl = URL.createObjectURL(blob)

        const anchor = document.createElement('a')
        anchor.href = blobUrl
        anchor.download = item.fileName || 'downloaded-image'

        document.body.appendChild(anchor)
        anchor.click()
        document.body.removeChild(anchor)

        setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl)
        }, 100)
      })
      .catch(e => console.error('Image download failed:', e))
  }

  // Location address change
  const onAddressChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    setLocation(event.target.value)
  }

  // Remove photo
  const handleRemovePicture = () => {
    mutate({ projectId: item?.project, photoId: item?.id })
    setOpenDialog(false)
    setOpenDetailModal(false)
    toggleSnackbar("Photo deleted successfully","success")
  }

  // Update Detail
  const handleUpdateDetail = async () => {
    setIsLoading(true)

    try {
      await updateProjectImages({
        projectId: item?.project,
        photoId: item?.id,
        formData: {
          fileName: title + '.' + item.fileName?.split('.').at(-1),
          exif: {
            ...item?.exif,
            location: location,
            position: {
              lat: lat,
              lng: lng,
            },
          },
          notes: tags
            .map(tag => tag.trim())
            .filter(tag => tag !== '')
            .join(','), // Joining trimmed and non-empty tags
        },
      })

      setIsLoading(false)
      setOpenDetailModal(false)
    } catch (error) {
      console.error('Error uploading files:', error)
      setIsLoading(false)
    } finally {
      setOpenDetailModal(false)
    }
  }

  // Use Effects
  useEffect(() => {
    if (item) {
      let formattedTags = []
      if (item.notes !== '') {
        formattedTags = item?.notes?.split(',')?.map((tag: any) => tag?.trim())
      }

      const nameArr = item.fileName.split('.')
      nameArr.pop()
      setTitle(nameArr.join('.'))
      setTags(formattedTags)

      if (item?.exif && item?.exif?.position) {
        setLat(item?.exif?.position?.lat)
        setLng(item?.exif?.position?.lng)
      }

      if (item?.exif && item?.exif?.location) {
        setLocation(item?.exif?.location)
      }
    }
  }, [item])

  return (
    <Grid item xs={2}>
      <Box
        sx={{
          backgroundColor: 'white',
          borderRadius: '10px',
          overflow: 'hidden',
          border: '1px solid #E5E2EB',
        }}>
        {imageTypes.includes(item.contentType) ? (
          <img
            src={item?.thumbnailPath}
            onClick={() => {
              setOpen(true)
            }}
            style={{
              cursor: 'pointer',
              width: '100%',
              height: '100%',
              aspectRatio: '100/100',
              objectFit: 'cover',
            }}
          />
        ) : (
          <video
            onClick={() => {
              setOpen(true)
            }}
            style={{
              cursor: 'pointer',
              width: '100%',
              height: '100%',
              aspectRatio: '100/100',
              objectFit: 'cover',
            }}
          >
            <source src={item.filePath} type="video/mp4" />
          </video>
        )}
        <Typography
          sx={{
            fontWeight: '400',
            fontSize: 16,
            color: '#5A525B',
            paddingTop: 1,
            paddingLeft: 2,
            paddingRight: 2,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%',
          }}>
          {item?.fileName}
        </Typography>
        <Typography
          sx={{
            fontWeight: '400',
            fontSize: 15,
            color: '#938994',
            paddingBottom: 1,
            paddingLeft: 2,
            paddingRight: 2,
          }}>
          {formatDateTime(item?.createdAt)}
          {/* Sep 13, 2023, 5:29 PM EDT */}
        </Typography>
      </Box>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'>
        <Box
          sx={{
            ...style,
            width: '100%',
            maxWidth: '50vw',
            maxHeight: '95vh',
            m: 0,
            p: 2,
            overflow: 'hidden',
            '::-webkit-scrollbar': {
              display: 'none',
            },
          }}>
          {imageTypes.includes(item.contentType) ? (
            <img
              src={item?.filePath}
              style={{
                width: '100%',
                height: '100%',
                borderRadius: '10px',
                padding: 0,
                margin: 0,
                objectFit: 'cover',
              }}
            />
          ) : (
            <video
              controls
              style={{
                width: '100%',
                borderRadius: '10px',
                padding: 0,
                margin: 0,
              }}
            >
              <source src={item.filePath} type="video/mp4" />
            </video>
          )}
          <Box
            sx={{
              position: 'fixed',
              bottom: 40,
              left: 0,
              right: 0,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'row',
            }}>
            <Button
              variant='contained'
              sx={{
                padding: theme.spacing(1.5, 3, 1.5, 3),
                borderRadius: '8px',
                textTransform: 'capitalize',
                width: 120,
                fontSize: '13px',
                backgroundColor: '#24212C',
                boxShadow: 'none',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#24212C',
                  boxShadow: 'none',
                  color: 'white',
                },
              }}
              onClick={() => {
                setOpen(false)
              }}>
              <Close /> <Box sx={{ width: 10 }} /> Close
            </Button>
            <Box sx={{ width: 20 }} />
            <Button
              variant='contained'
              sx={{
                padding: theme.spacing(1.5, 3, 1.5, 3),
                borderRadius: '8px',
                textTransform: 'capitalize',
                width: 150,
                fontSize: '13px',
                marginLeft: 2,
                whiteSpace: 'nowrap',
                boxShadow: 'none',
                '&:hover': {
                  boxShadow: 'none',
                },
              }}
              onClick={() => {
                setOpenDetailModal(true)
                setOpen(false)
              }}>
              <CameraIcon /> <Box sx={{ width: 10 }} /> View Details
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Photo Detail Modal */}

      <Modal
        open={openDetailModal}
        onClose={() => setOpenDetailModal(false)}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'>
        <Box
          sx={{
            ...style_detail,
            aspectRatio: 570 / 763,
            height: '100vh',
            maxHeight: '100vh',
            m: 0,
            overflow: 'hidden',
            '::-webkit-scrollbar': {
              display: 'none',
            },
            width: '90%',
          }}>
          <Grid container spacing={3}>
            <Grid item xs={8}>

              {imageTypes.includes(item.contentType) ? (
                <img
                  src={item?.filePath}
                  style={{
                    cursor: 'pointer',
                    width: '100%',
                    height: '100vh',
                    aspectRatio: '132/100',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <video
                  controls
                  style={{
                    cursor: 'pointer',
                    width: '100%',
                    height: '100vh',
                    aspectRatio: '132/100',
                    objectFit: 'cover',
                  }}
                >
                  <source src={item.filePath} type="video/mp4" />
                </video>
              )}
            </Grid>

            <Grid item xs={4}>
              <Box
                display='flex'
                alignItems={'center'}
                justifyContent={'space-between'}
                marginBottom={2.5}
                marginTop={2.5}
                position={'relative'}
                width='100%'>
                <Box
                  display='flex'
                  alignItems={'center'}
                  justifyContent={'space-between'}>
                  <>
                    {['Details'].map((item, index) => {
                      const isSelected = selectedTab == item
                      return (
                        <Box
                          sx={{
                            marginRight: 2.5,
                            cursor: 'pointer',
                            color: '#2B262C',
                          }}
                          onClick={() => {
                            setSelectedTab(item)
                          }}
                          key={index}>
                          <Typography
                            sx={{
                              fontFamily: 'Rza',
                              fontSize: 20,
                              fontWeight: '600',
                              opacity: isSelected ? 1 : 0.6,
                            }}>
                            {item}
                          </Typography>
                          <Box
                            sx={{
                              backgroundColor: isSelected ? '#F0845D' : 'white',
                              width: '100%',
                              height: 1.7,
                            }}
                          />
                        </Box>
                      )
                    })}
                  </>

                  <Box
                    sx={{
                      cursor: 'pointer',
                      position: 'absolute',
                      right: '1rem',
                    }}>
                    <Close
                      sx={{
                        color: '#938894',
                        fontSize: '1.5rem',
                      }}
                      onClick={() => setOpenDetailModal(false)}
                    />
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                  marginTop: '30px',
                }}>
                <Button
                  variant='contained'
                  sx={{
                    borderRadius: '8px',
                    textTransform: 'capitalize',
                    fontSize: '13px',
                    whiteSpace: 'nowrap',
                    boxShadow: 'none',
                    '&:hover': {
                      boxShadow: 'none',
                    },
                    marginRight: '10px',
                    paddingInline: '10px',
                    paddingBlock: '3px',
                  }}
                  onClick={() => downloadImage(item.filePath)}>
                  <DownloadIconNew /> <Box sx={{ width: 5 }} /> Download
                </Button>

                <Button
                  variant='contained'
                  sx={{
                    borderRadius: '8px',
                    textTransform: 'capitalize',
                    fontSize: '13px',
                    whiteSpace: 'nowrap',
                    boxShadow: 'none',
                    backgroundColor: '#59A0A0',
                    '&:hover': {
                      boxShadow: 'none',
                      backgroundColor: '#397676',
                    },
                    marginRight: '10px',
                    paddingInline: '10px',
                    paddingBlock: '3px',
                  }}
                  onClick={handleShareDialogOpen}>
                  <ShareIcon /> <Box sx={{ width: 5 }} /> Share
                </Button>
                {/* Share Dialog */}
                <ShareDialogComponent
                  openShareDialog={openShareDialog}
                  handleShareDialogClose={handleShareDialogClose}
                  copyPhotoUrlToClipboard={copyPhotoUrlToClipboard}
                  shareOnFacebook={shareOnFacebook}
                  shareViaEmail={shareViaEmail}
                />
                <Button
                  variant='contained'
                  sx={{
                    borderRadius: '8px',
                    textTransform: 'capitalize',
                    fontSize: '13px',
                    whiteSpace: 'nowrap',
                    boxShadow: 'none',
                    backgroundColor: '#C6908B',
                    '&:hover': {
                      boxShadow: 'none',
                      backgroundColor: '#C67A73',
                    },
                    paddingInline: '10px',
                    paddingBlock: '3px',
                  }}
                  onClick={() => setOpenDialog(true)}>
                  <DeleteNew /> <Box sx={{ width: 5 }} /> Remove
                </Button>
                <Dialog
                    open={openDialog}
                    onClose={()=>setOpenDialog(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    >
                  <DialogTitle id="alert-dialog-title">
                    {"Delete Confirmation"}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Are you sure you want to delete this photo?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                      <Button onClick={()=> setOpenDialog(false)}
                      sx={{"&:hover": {backgroundColor: "#f0f0f0",}}}>
                        Cancel
                      </Button>
                      <Button 
                        onClick={
                        handleRemovePicture
                        }
                        autoFocus
                        sx={{"&:hover": {backgroundColor: "#f0f0f0",}}}          
                      >
                        Yes
                      </Button>
                  </DialogActions>
                </Dialog>
              </Box>

              <Box
                sx={{
                  height: '76vh',
                  overflowY: 'auto',
                  marginTop: '10px',
                  paddingRight: '15px',
                  width: '100%',
                }}>
                <Box
                  alignItems={'center'}
                  justifyContent={'center'}
                  display={'flex'}
                  sx={{
                    padding: '10px 2px',
                    borderBottom: '1px solid #D7D4DE',
                  }}>
                  <Typography sx={{ color: '#7C7A80', width: '100%' }}>
                    Taken by
                  </Typography>
                  <Typography sx={{ color: '#2B262C', width: '100%' }}>
                    {/* {item?.fileName} */} ---
                  </Typography>
                </Box>

                <Box
                  alignItems={'center'}
                  justifyContent={'center'}
                  display={'flex'}
                  sx={{
                    padding: '10px 2px',
                    borderBottom: '1px solid #D7D4DE',
                  }}>
                  <Typography sx={{ color: '#7C7A80', width: '100%' }}>
                    Taken on
                  </Typography>
                  <Typography sx={{ color: '#2B262C', width: '100%' }}>
                    {item?.exif?.exif?.CreateDate
                      ? formatDateTime(
                        moment(
                          item?.exif?.exif?.CreateDate,
                          'YYYY:MM:DD HH:mm:ss'
                        )
                          .toDate()
                          .toString()
                      )
                      : '----'}
                  </Typography>
                </Box>

                <Box
                  alignItems={'center'}
                  justifyContent={'center'}
                  display={'flex'}
                  sx={{
                    padding: '10px 2px',
                    borderBottom: '1px solid #D7D4DE',
                  }}>
                  <Typography sx={{ color: '#7C7A80', width: '100%' }}>
                    Added on
                  </Typography>
                  <Typography sx={{ color: '#2B262C', width: '100%' }}>
                    {moment(item.createdAt)
                      // .tz('America/New_York')
                      .format('MMM D, YYYY, h:mm A z')}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    width: '100%',
                    marginTop: '20px',
                  }}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Title
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      borderRadius: '8px',
                      border: '1px solid #DBDBDB',
                      padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                    }}
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}>
                    <Input
                      disableUnderline
                      sx={{
                        width: '100%',
                        fontSize: '17px',
                        '& input::placeholder': {
                          fontWeight: 'bold',
                        },
                      }}
                      type='text'
                      fullWidth={true}
                      onChange={(e: any) => setTitle(e.target.value)}
                      value={title}
                      required={true}
                      disabled={false}
                    />
                  </Box>
                </Box>

                <Box width='100%' sx={{ marginTop: 2 }}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Location
                  </Typography>
                  <StandaloneSearchBox
                    onLoad={(ref: any) => (locationFieldRef.current = ref)}
                    onPlacesChanged={() => {
                      const place = locationFieldRef?.current?.getPlaces()[0]
                      if (place) {
                        setLocation(place?.formatted_address)
                        setLat(place?.geometry?.location.lat())
                        setLng(place?.geometry?.location.lng())
                      }
                    }}>
                    <Box
                      sx={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        border: '1px solid #DBDBDB',
                        width: '100%',
                        padding: theme.spacing(0.8, 1.6, 0.8, 1.6),
                      }}
                      display={'flex'}
                      alignItems={'center'}
                      justifyContent={'center'}>
                      <Input
                        disableUnderline
                        sx={{
                          width: '100%',
                          fontSize: '17px',
                        }}
                        placeholder={''}
                        key={`0_searchbox`}
                        id={`0_location`}
                        name={`0_location`}
                        type='text'
                        fullWidth={true}
                        value={location}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          onAddressChange(e)
                        }
                        required={true}
                      />
                    </Box>
                  </StandaloneSearchBox>
                </Box>

                <Box width='100%' sx={{ marginTop: 2 }}>
                  <Typography
                    fontSize={'14px'}
                    color='#5A525B'
                    paddingBottom={0.5}
                    fontWeight='bold'>
                    Tags
                  </Typography>
                  <SelectTagsComponent
                    isFullWidth={1}
                    tags={tags}
                    setTags={setTags}
                  />
                </Box>

                <Box>
                  <Typography
                    sx={{
                      fontSize: '14px',
                      color: '#5A525B',
                      width: '100%',
                      fontWeight: '600',
                      marginTop: 2,
                    }}>
                    GPS Location
                  </Typography>
                  <GoogleMap
                    key={`1_map`}
                    id={`1_map`}
                    mapContainerStyle={{
                      width: '100%',
                      height: '200px',
                      marginTop: 10,
                      borderRadius: '10px',
                    }}
                    center={{
                      lat: lat,
                      lng: lng,
                    }}
                    zoom={15}
                    options={{
                      clickableIcons: false,
                      disableDefaultUI: true,
                    }}>
                    <Fragment>
                      <MarkerF
                        position={{
                          lat: lat,
                          lng: lng,
                        }}
                        label={''}></MarkerF>
                    </Fragment>
                  </GoogleMap>
                </Box>

                <Box
                  sx={{
                    paddingBlock: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'white',
                    position: 'absolute',
                    bottom: '0',
                    width: '32%',
                    boxShadow: '0px 2px 4px 0px #0000000D',
                  }}>
                  <Button
                    variant='contained'
                    sx={{
                      borderRadius: '8px',
                      textTransform: 'capitalize',
                      fontSize: '13px',
                      backgroundColor: '#24212C',
                      boxShadow: 'none',
                      color: 'white',
                      '&:hover': {
                        backgroundColor: '#24212C',
                        boxShadow: 'none',
                        color: 'white',
                      },
                      marginRight: '20px',
                    }}
                    onClick={() => {
                      setOpenDetailModal(false)
                    }}>
                    <Close /> <Box sx={{ width: 10 }} /> Close
                  </Button>

                  <Button
                    variant='contained'
                    sx={{
                      borderRadius: '8px',
                      textTransform: 'capitalize',
                      fontSize: '13px',
                      whiteSpace: 'nowrap',
                      boxShadow: 'none',
                      '&:hover': {
                        boxShadow: 'none',
                      },
                      marginRight: '10px',
                    }}
                    onClick={() => handleUpdateDetail()}>
                    <CheckCircleOutline /> <Box sx={{ width: 5 }} /> Update
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Grid>
  )
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '1px solid #CCCCCC',
  borderRadius: '22px',
  boxShadow: 24,
  p: 3,
  overlay: {
    background: '#FFFF00',
  },
}

const style_detail = {
  position: 'absolute' as 'absolute',
  top: '50%',
  right: '0%',
  transform: 'translate(0%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  overlay: {
    background: '#FFFF00',
  },
}
